// extracted by mini-css-extract-plugin
export default {"settings":"SettingsPage_settings__ePu-a","settings__theme":"SettingsPage_settings__theme__zwrIo"};